document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 989) {
    document.querySelectorAll('.footer-block').forEach(function (block) {
      var heading = block.querySelector('.footer-block__heading');
      if (!heading) return;
      heading.addEventListener('click', function () {
        block.classList.toggle('footer-block--open');
      });
    });
  }
});

function updateGuaranteesFontSize() {
  var isMobile = window.innerWidth <= 749;
  document.querySelectorAll('[id^="Details-shipping-accordion-"] .accordion__content p').forEach(function (p) {
    if (isMobile) {
      p.style.setProperty('font-size', '1.3rem', 'important');
    } else {
      p.style.setProperty('font-size', '16px', 'important');
    }
  });
}
document.addEventListener('DOMContentLoaded', updateGuaranteesFontSize);
window.addEventListener('resize', updateGuaranteesFontSize);